import React from "react";
import { BadgeCheckIcon, StarIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/testimonials";
export function Testimonials() {
  return <section className="bg-brand-soft px-4 py-16 sm:px-6 sm:py-20" data-id="element-349" data-mp="3mepjgqfklrpv">
      <div className="mx-auto max-w-6xl" data-id="element-350" data-mp="3r8amiww0tbvx">
        <SectionHeading kicker="What professionals think" title="A structured approach to hair loss education" intro="Professional feedback can help other buyers understand whether the collection fits their educational needs." data-id="element-351" data-mp="3r9bzx80ieagt" />

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-352" data-mp="92fethe1i1vq">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-white p-5 sm:p-6" data-id="element-353" data-mp="e07g320kr0cl">
              <div className="flex items-center gap-4" data-id="element-354" data-mp="2autyakw8fee9">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-brand-soft" loading="lazy" data-id="element-355" data-mp="2fru1mo1p631o" />
                <div className="min-w-0" data-id="element-356" data-mp="1ns9hp63tehnf">
                  <p className="flex items-center gap-1 font-bold text-ink" data-id="element-357" data-mp="1iupsxc9hqmh8">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-label="Verified buyer" data-id="element-358" data-mp="1ete9xpl4gzi0" />
                  </p>
                  <p className="text-sm leading-snug text-ink-muted" data-id="element-359" data-mp="2bic69c8it5ha">{t.role}</p>
                </div>
              </div>
              <div className="mt-4 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-360" data-mp="26ktw5iirok7p">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-361" data-mp="1xjm8rvhsh3se" data-mpi={i} />)}
              </div>
              <blockquote className="mt-3 text-[17px] leading-relaxed text-ink" data-id="element-362" data-mp="r4lavk97ebj6">“{t.quote}”</blockquote>
              <p className="mt-auto pt-4 text-xs font-extrabold uppercase tracking-[0.14em] text-brand" data-id="element-363" data-mp="m3fencgc464w">
                On the {t.topic}
              </p>
            </li>)}
        </ul>

        <CTAButton className="mt-10" label="Yes! I want the complete Blueprint™" note="One-time payment · $27 USD" data-id="element-364" data-mp="sjo2mmz6wt0t" />
      </div>
    </section>;
}